export default __webpack_public_path__ + "static/media/banner1.281dfb9b.jpg";